/* eslint-disable import/no-unresolved */
import PropTypes from 'prop-types';
// Components
import Logo from '../../../assets/logo-baseline.svg?react';
import Bubble from '../../../assets/illustrations/zol-bubble.svg?react';
import illus from '../../../assets/illustrations/zol-chien.webp';
import Loader from '../../../assets/icons/loader.svg?react';
// Styles
import styles from './PageSignIn.module.css';

export function PageSignIn({ label, isLoading, action }) {
  return (
    <div className={styles.wrapper}>
      <Bubble className={styles.bubble} />
      <img src={illus} className={styles.illus} alt="zol mascotte" />

      <Logo className={styles.logo} />

      <div className={styles.login}>
        <div className={styles.message}>
          {isLoading ? <Loader /> : null}
          {label}
        </div>
        {action}
      </div>
    </div>
  );
}

// Props volontairement requises : `defaultProps` est déprécié sur les composants
// fonctionnels et la règle react/require-default-props n'accepte pas encore les
// paramètres par défaut sur ce dépôt.
PageSignIn.propTypes = {
  label: PropTypes.string.isRequired,
  isLoading: PropTypes.bool.isRequired,
  action: PropTypes.node.isRequired,
};

export default PageSignIn;
